'use strict';
require('./warnAboutDeprecatedCJSRequire.js')('createMemoryHistory');
module.exports = require('./index.js').createMemoryHistory;



//////////////////
// WEBPACK FOOTER
// ./~/history/createMemoryHistory.js
// module id = 1302
// module chunks = 4